import { ESdkEvents, EventParams } from './contracts';
import { InternalMessageEventsName } from './constants/enums';
import { frontendEventsService } from './services/frontend-events.service';

/**
 * Emits a checkout lifecycle event on both channels:
 *   1. `postMessage` to the parent (publisher SDK contract — unchanged)
 *   2. authenticated POST to events-gateway via `frontend-events-sdk`
 *
 * The SDK track is invoked in `finally` so a `postMessage` throw never
 * suppresses the data-lake event. `frontendEventsService.track` itself
 * never throws / never blocks.
 */
const sendFEEvent = (eventName: ESdkEvents, params: Partial<EventParams>) => {
  const sessionId = location.pathname.slice(1);
  const eventParams: Partial<EventParams> = { ...params, sessionId };
  try {
    window.parent.postMessage(
      {
        event: eventName,
        params: eventParams,
      },
      '*',
    );
  } finally {
    frontendEventsService.track(eventName, eventParams);
  }
};

const sendInternalFEEvent = (
  customWindow: Window | null,
  eventName: InternalMessageEventsName,
  params: any = {},
) => {
  const eventData = {
    event: eventName,
    params,
  };
  customWindow?.postMessage(eventData);
};

export { sendFEEvent, sendInternalFEEvent };
